<div class="modal-header">
  <h3 class="modal-title">Program FAQ</h3>
</div>
<div class="modal-body">
  <strong>How do I update my flight school's listing?</strong>
  <p>Visit YoungEagles.org/lesson and search by state for your flight school. Flight school listings are sorted by zip code. Once you have found your school, click on the "Update School Information" link and submit new information.</p>
  <strong>How can I check on the status of payment?</strong>
  <p>It may take up to 10 days for payment to reach your school if requesting payment by check. To check on the status of your payment, contact Mark Wiesenhahn at mark.w&#64;sportys.com or 513.735.9100, ext. 338.</p>
  <strong>How much will my school be paid for the lesson?</strong>
  <p>EAA will pay your school $160 for the flight lesson you provide to the Young Eagle (payment processing provided by Sporty's Pilot Shop).</p>
  <strong>How long should the lesson last?</strong>
  <p>The Introductory Flight Lesson should include 45 - 60 minutes of flight time and include a preflight inspection.</p>
  <strong>Do I need to verify proof of US Citizenship to conduct the Introductory Flight Lesson?</strong>
  <p>It is ultimately the decision of the flight school as to whether proof of citizenship will be required; however, guidance from TSA does not require such verification for discovery, familiarization or introductory flights.</p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary w-25" (click)="close()">OK</button>
</div>
